import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/main.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

/*
 * StrictMode off: dev double-mount remounts Clerk SignUp → duplicate/invalid OTP.
 * Debug: REACT_APP_AUTH_DEBUG=true → [auth:mount], [auth:route], [auth:otp-api], [auth:signup-state]
 */
root.render(<App />);